<!-- Container-fluid starts-->
<div class="container-fluid">
    <div class="card">
        <div class="card-header">
            <h5>User Details</h5>
        </div>
        <div class="card-body">
            <div class="btn-popup pull-right">
                <a class="btn btn-primary" [routerLink]="'/users/create-user'">Create User</a>
            </div>
            <div id="batchDelete" class="category-table custom-datatable transcation-datatable user-image">
                <div class="table-responsive">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col" >Actions</th>
                                <th scope="col" sortable="avatar" (sort)="onSort($event)">Avtar</th>
                                <th scope="col" sortable="fName" (sort)="onSort($event)">First Name</th>
                                <th scope="col" sortable="lName" (sort)="onSort($event)">Last Name</th>
                                <th scope="col" sortable="email" (sort)="onSort($event)">Email</th>
                                <th scope="col" sortable="last_login" (sort)="onSort($event)">Last Login</th>
                                <th scope="col" sortable="role" (sort)="onSort($event)">Role</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of tableItem$ | async ">
                                <td>
                                    <a href="javascript:void(0)"><i class='fa fa-edit f-12'></i></a>&nbsp;
                                    <a href="javascript:void(0)"><i class="fa fa-trash-o"></i></a>
                                </td>
                                <td scope="row">
                                    <img [src]="item.avatar" class="imgTable" style="width: 20px">
                                </td>
                                <td>
                                    {{item.fName}}
                                </td>
                                <td>{{item.lName}}</td>
                                <td>{{item.email}}</td>
                                <td>{{item.last_login}}</td>
                                <td>{{item.role}}</td>
                            </tr>
                        </tbody>
                    </table> 
                    <div class="d-flex justify-content-center p-2">
                        <ngb-pagination
                          [collectionSize]="(total$ | async)!" [(page)]="service.page" [pageSize]="service.pageSize">
                        </ngb-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Container-fluid Ends-->